module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright1"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("NEW YORK UNIVERSITY PRESS")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("New York and London"), _c('br'), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.nyupress.org",
      "target": "_blank"
    }
  }, [_vm._v("www.nyupress.org")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("© 2011 by New York University")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("References to Internet websites (URLs) were accurate at the time of writing. Neither the author nor New York University Press is responsible for URLs that may have expired or changed since the manuscript was prepared.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Raphael, Marc Lee.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The synagogue in America : a short history / Marc Lee Raphael.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN 978-0-8147-7582-0 (cl : alk. paper)—ISBN 978-0-8147-7704-6 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("1. Synagogues—United States—History. 2. Judaism—United States —")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("History. 3. Jews—United States—History. 4. Jews—United States —")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Social life and customs. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("BM205.R372 2011")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("296.6'50973—dc22                                2010047146")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("New York University Press books are printed on acid-free paper, and their binding materials are chosen for strength and durability. We strive to use environmentally responsible suppliers and materials to the greatest extent possible in publishing our books.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-322dcd54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 63
// module chunks = 0